import React, {
    createContext,
    Dispatch,
    ReactNode,
    useContext,
    useState,
    useEffect,
} from "react"
import {RfidInfo} from "types/rfid"

export interface RfidContextProps {
    currentCardSelected:  RfidInfo | null;
    setCurrentCardSelected: Dispatch<React.SetStateAction<RfidInfo | null>>;
    fetchListRfid: RequestFunction,
    rfidCurrentStatus:() => 1 | 2 | 0,
    stateDisableCard: () => void,
    stateReactivateCard: () => void,
    closeRfidPopup: () => void,
    disableCard: boolean,
    reactivateCard: boolean,
    disableCardConfirm: boolean,
    openUpdateRuleCard: boolean,
    setDisableCard: React.Dispatch<React.SetStateAction<boolean>>,
    setReactivateCard: React.Dispatch<React.SetStateAction<boolean>>,
    setDisableCardConfirm: React.Dispatch<React.SetStateAction<boolean>>,
    setOpenUpdateRuleCard: React.Dispatch<React.SetStateAction<boolean>>,
    viewMode: RfidViewMode,
    setViewMode: React.Dispatch<React.SetStateAction<RfidViewMode>>
    getFilteredRows: (rows: RfidInfo[]) => RfidInfo[]
    selectedButton: "ALL" | "VEHICLE" | "DRIVER",
    setSelectedButton: React.Dispatch<React.SetStateAction<"ALL" | "VEHICLE" | "DRIVER">>
    displayTable: "card" | "table",
    setDisplayTable: React.Dispatch<React.SetStateAction<"card" | "table">>
    tableButton: boolean,
    setTableButton: React.Dispatch<React.SetStateAction<boolean>>
}

export const RfidContext = createContext<RfidContextProps | null>(null);

export type RfidViewMode = 'LIST' | 'ACTIVATION' | 'EDIT';

export const RfidProvider: React.FC<{ children: ReactNode, fetchListRfid: RequestFunction}> = ({ children, fetchListRfid }) => {

    const [currentCardSelected, setCurrentCardSelected] = useState<null |RfidInfo>(null)
    const [disableCard, setDisableCard] = useState(false)
    const [disableCardConfirm, setDisableCardConfirm] = useState(false)
    const [reactivateCard, setReactivateCard] = useState(false)
    const [openUpdateRuleCard, setOpenUpdateRuleCard] = useState(false)
    const [viewMode, setViewMode] = useState<RfidViewMode>('LIST');
    const [tableButton, setTableButton] = useState(false) // PATCH A ENLEVER SI ON ENLEVER REACTIVER/ DESACTIVER DU RFID TABLEAU
    const [selectedButton, setSelectedButton] = useState<"ALL" | "VEHICLE" | "DRIVER">("ALL");
    const [displayTable, setDisplayTable] = useState<"card" | "table">("card");

    const getFilteredRows = (rows: RfidInfo[] ) => {
        if (selectedButton === "ALL") return rows
        return rows.filter((row) => row.cardHolderType === selectedButton)
    }

    const rfidCurrentStatus = () => {
        if (disableCard || disableCardConfirm)
            return 1
        if (reactivateCard)
            return 2
        return 0
    }

    const stateDisableCard = () => {
        setDisableCard(true)
        setReactivateCard(false)
    }

    const stateReactivateCard = () => {
        setDisableCard(false)
        setReactivateCard(true)
    }

    const closeRfidPopup = () => {
        setDisableCard(false)
        setReactivateCard(false)
        setDisableCardConfirm(false)
        setOpenUpdateRuleCard(false)
    }

    useEffect(() => {
        fetchListRfid()
    }, [])

    return <RfidContext.Provider value={{
        currentCardSelected,
        setCurrentCardSelected,
        fetchListRfid,
        rfidCurrentStatus,
        stateReactivateCard,
        stateDisableCard,
        closeRfidPopup,
        disableCard,
        reactivateCard,
        openUpdateRuleCard,
        setDisableCard,
        setReactivateCard,
        disableCardConfirm,
        setDisableCardConfirm,
        setOpenUpdateRuleCard,
        viewMode,
        setViewMode,
        getFilteredRows,
        selectedButton,
        setSelectedButton,
        displayTable,
        setDisplayTable,
        tableButton,
        setTableButton
    }}>{children}</RfidContext.Provider>;

}

export const UseRfidContext = () => {
    const context = useContext(RfidContext);
    if (!context) {
        throw new Error('RfidContext must be used within an RfidProvider');
    }
    return context;
};
